<template>
  <div class="home" style="width:100%;">
    <v-row v-if="!loader">
      <v-col cols="3">
        <h2>Appointment Calendar</h2>
        <v-card outlined>
          <span class="d-flex flex-row align-center">
            <v-card-title>Filters</v-card-title>
            <v-btn x-small @click="clearFilters" class="mr-2" fab color="error"><v-icon>mdi-refresh</v-icon></v-btn>
          </span>
          <v-chip-group class="mx-4" row>
            <v-chip v-if="this.filters.tailorId" dense>Tailor</v-chip>
            <v-chip v-if="this.filters.jobId" dense>Job</v-chip> 
            <v-chip v-if="this.filters.eventType" dense>Event Type</v-chip>
            <v-chip v-if="this.filters.gender" dense>Gender</v-chip>
          </v-chip-group>
          <v-card-text>
            <v-autocomplete
              :items="statuses"
              :item-text="x => x.name"
              item-value="value"
              label="Filter by Status"
              dense
              clearable
              outlined
              v-model="filters.status"
              @change="filterByStatus()"
            />
            <v-autocomplete
              :items="types"
              :item-text="x => x.name"
              item-value="id"
              label="Filter by Type"
              dense
              clearable
              outlined
              v-model="filters.type"
              @change="filterByType()"
            />
            <v-autocomplete
              :items="this.getUserCache"
              :item-text="x => x.firstName +' '+ x.lastName"
              item-value="id"
              label="Filter by CSR"
              dense
              clearable
              outlined
              v-model="filters.csr"
              @change="filterByCSR()"
            />
            <v-autocomplete
              :items="genders"
              item-text="name"
              item-value="value"
              label="Filter by Gender"
              dense
              clearable
              outlined
              v-model="filters.gender"
              @change="filterByGender()"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="9">
        <div class="d-flex flex-row">
          <h2>Appointments</h2>
          <v-btn x-small @click="openCreateAppointmentDialog" class="mx-2" fab color="success"><v-icon>mdi-plus</v-icon></v-btn>
        </div>
        <span class="d-flex flex-row align-center">
          <!-- <span style="width: 12px; height: 12px; border-radius: 12px; background-color: #FF9800;"></span><span class="ml-1">Date Out</span> -->
          <div style="width: 12px; height: 12px; border-radius: 12px;" class="ml-3 warning"></div><div class="ml-1">Pending ({{eventsToDisplay.filter(x => x.start>=viewStart && x.start &lt;= viewEnd && x.appointment.status===0).length|| 0}})</div>
          <div style="width: 12px; height: 12px; border-radius: 12px;" class="ml-3 success"></div><div class="ml-1">Started ({{eventsToDisplay.filter(x => x.start>=viewStart && x.start &lt;= viewEnd && x.appointment.status===1).length|| 0}})</div>
          <div style="width: 12px; height: 12px; border-radius: 12px;" class="ml-3 info"></div><div class="ml-1">Complete ({{eventsToDisplay.filter(x => x.start>=viewStart && x.start &lt;= viewEnd && x.appointment.status===2).length|| 0}})</div>
          <div style="width: 12px; height: 12px; border-radius: 12px;" class="ml-3 purple"></div><div class="ml-1">Sealed ({{eventsToDisplay.filter(x => x.start>=viewStart && x.start &lt;= viewEnd && x.appointment.status===3).length|| 0}})</div>
          <div style="width: 12px; height: 12px; border-radius: 12px;" class="ml-3 error"></div><div class="ml-1">Cancelled ({{eventsToDisplay.filter(x => x.start>=viewStart && x.start &lt;= viewEnd && x.appointment.status===-1 || x.appointment.status===-2).length|| 0}})</div>
          <span class="ml-3" style="font-size: 11px;"><v-icon>mdi-phone</v-icon> Call ({{eventsToDisplay.filter(x => x.start>=viewStart && x.start &lt;= viewEnd && x.appointment.appointmentType===2).length || 0}})</span>
          <span class="ml-3" style="font-size: 11px;"><v-icon>mdi-walk</v-icon> Walk-In ({{eventsToDisplay.filter(x => x.start>=viewStart && x.start &lt;= viewEnd && x.appointment.appointmentType===1).length || 0}})</span>
<!--          <span class="ml-3" style="font-size: 11px;">👗 Formal</span>-->
<!--          <span class="ml-3" style="font-size: 11px;">💍 Bridal</span>-->
        </span>
        <v-sheet height="64">
          <v-toolbar flat>
            <v-btn outlined class="mr-4" color="grey darken-2" @click="setTodayWeek" >Refresh</v-btn>
            <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday" >View Today</v-btn>
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon small>mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon small>mdi-chevron-right</v-icon>
            </v-btn>
            <v-progress-circular
                indeterminate
                color="green"
                v-if="calenderLoader"
                style="margin-left: 10px;"
            />
            <v-spacer></v-spacer>
            <v-menu bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  color="grey darken-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right>
                    mdi-menu-down
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Day</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Week</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Month</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = '4day'">
                  <v-list-item-title>4 days</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-sheet>
        <v-sheet height="600">
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            :events="eventsToDisplay"
            :event-color="getEventColor"
            :type="type"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="updateRange"
          />
          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
          >
            <v-card
              color="grey lighten-4"
              min-width="350px"
              flat
            >
              <v-toolbar
                :color="selectedEvent.color"
                dark
              >
                <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon @click="goToAppointment(selectedEvent.appointment.id)">mdi-chevron-right</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text v-if="selectedEvent.appointment">
                <span class="d-flex flex-column">
                  <h3>Current Status: {{utils.parseAppointmentStatus(selectedEvent.appointment.status)}}</h3>
                  <b>Customer: {{selectedEvent.appointment.Customer.firstName}} {{selectedEvent.appointment.Customer.lastName}} | {{selectedEvent.appointment.Customer.phone}}</b >
                  <b>Gender: {{parseAppointmentGender(selectedEvent.appointment.gender)}}</b>
                  <b>Intentions: <v-chip class="mr-2" small color="info" v-for="(intention, index ) in selectedEvent.appointment.intentions" :key=index>{{ lookupIntention(intention).name }}</v-chip ></b>
                  <b>Wedding Date: {{this.utils.customFormatDate(selectedEvent.appointment.weddingDate, "notime")}}</b>
                  <b>Booking Type: {{parseAppointmentType(selectedEvent.appointment.appointmentType)}}</b>
                  <b>Budget: ${{selectedEvent.appointment.budget}}</b>
                </span>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  text
                  color="secondary"
                  @click="selectedOpen = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-sheet>
      </v-col>
      <v-col class="col-md-2">
      </v-col>
    </v-row>
    <v-dialog scrollable v-model="createAppointmentDialog.isOpen" max-width="1600">
      <v-card>
        <v-card-title><h2 class="pt-3">Create New Appointment</h2></v-card-title>
        <v-card-text class="pa-5">
          <v-form class="d-flex flex-row" style="width: 100%;">
            <span style="width:60%;">
              <v-card outlined>
                <v-card-title>
                  <h3>Customer Information</h3>
                </v-card-title>
                <v-card-text class="d-flex flex-column">
                  <span class="d-flex flex-row">
                    <v-text-field :loading="findCustomerByPhoneLoader" ref="customerPhone" v-model="createAppointmentDialog.appointment.customerPhone" @keyup="findCustomerByPhone" label="Phone" outlined></v-text-field>
                    <v-text-field class="ml-3" outlined label="Customer Name" :disabled="createAppointmentDialog.appointment.customerId!=''" v-model="createAppointmentDialog.appointment.customerName" @change="updateAppointment()"/>
                  </span>
                  <span class="d-flex flex-row" v-if="newCustomer.suggestedMatches && newCustomer.suggestedMatches.length > 0">
                    <v-btn fab class="mr-2" x-small color="error" @click="clearCustomerSuggestions"><v-icon>mdi-close</v-icon></v-btn>
                    <div style="width: 100%; height: 100%;">
                      <v-chip class="mr-1 mb-2" v-for="suggestion in newCustomer.suggestedMatches" :key="suggestion.id" @click="setCustomer(suggestion)">
                        <b style="font-size: 12px;">{{suggestion.firstName}} {{suggestion.lastName}} | {{suggestion.phone}}</b>
                      </v-chip>
                    </div>
                  </span>
                  <span class="d-flex flex-row">
                    <v-text-field class="" outlined label="Customer Email" :disabled="createAppointmentDialog.appointment.customerId!=''" v-model="createAppointmentDialog.appointment.customerEmail" @change="updateAppointment()"/>
                    <v-text-field class="ml-3" outlined label="Address Line 1" :disabled="createAppointmentDialog.appointment.customerId!=''" v-model="createAppointmentDialog.appointment.customerLine1" @change="updateAppointment()"/>
                  </span>
                  <span class="d-flex flex-row">
                    <v-text-field class="" outlined label="Address Line 2" :disabled="createAppointmentDialog.appointment.customerId!=''" v-model="createAppointmentDialog.appointment.customerLine2" @change="updateAppointment()"/>
                    <v-text-field class="ml-3" outlined label="Address City" :disabled="createAppointmentDialog.appointment.customerId!=''" v-model="createAppointmentDialog.appointment.customerCity" @change="updateAppointment()"/>
                  </span>
                  <span>
                    <v-menu
                        :close-on-content-click="false"
                        :nudge-right="0"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            :value="utils.parseDate(createAppointmentDialog.appointment.weddingDate,2)"
                            label="Wedding Date"
                            readonly
                            outlined
                            clearable
                            v-bind="attrs"
                            v-on="on"
                            class="mr-2"
                        />
                      </template>
                      <v-date-picker
                          @change="updateAppointment()"
                          v-model="createAppointmentDialog.appointment.weddingDate"
                      />
                    </v-menu>
                  </span>
                </v-card-text>
              </v-card>
              <v-card class="mt-3" outlined>
                <v-card-title>
                  <h3>Reason for Appointment</h3>
                </v-card-title>
                <v-card-text>
                  <span class="d-flex flex-row">
                    <span class="mr-3" v-for="intention in intentions" :key="intention.id">
                      <v-checkbox @change="updateAppointment()" v-model="createAppointmentDialog.appointment.intentions" :label="intention.name" :value="intention.id"/>
                    </span>
                  </span>
                  <span class="d-flex flex-row">
                    <v-text-field outlined label="Max Budget" @change="updateAppointment()" type="number" v-model="createAppointmentDialog.appointment.budget"/>
                    <v-text-field outlined class="ml-3" label="Number of Persons" @change="updateAppointment()" type="number" v-model="createAppointmentDialog.appointment.occupants"/>
                    <v-select
                      :items="genders"
                      item-text="name"
                      item-value="id"
                      label="Gender"
                      outlined
                      class="ml-3"
                      v-model="createAppointmentDialog.appointment.gender"
                    />
                  </span>
                  <v-textarea label="Notes" @change="updateAppointment()" v-model="createAppointmentDialog.appointment.notes" dense outlined/>
                  <span class="d-flex flex-row">
                      <v-checkbox class="mr-3" v-model="createAppointmentDialog.appointment.isWalkIn" @change="updateAppointment()" label="Walk-In"/>
                      <v-checkbox class="mr-3" v-model="createAppointmentDialog.appointment.metadata.force" @change="updateAppointment()" label="Force Create"/>
                      <v-checkbox class="mr-3" v-model="createAppointmentDialog.appointment.metadata.firstAppointment" @change="updateAppointment()" label="First Appointment"/>
                  </span>
                </v-card-text>
              </v-card>
            </span>
            <div class="d-flex flex-column ml-3" style="background-color: rgba(0,0,0,0); width:40%">
              <v-card outlined>
                <v-card-title>
                  <h3>Select Date & Time</h3>
                </v-card-title>
                <v-card-text>
                  <v-date-picker full-width v-model="createAppointmentDialog.appointment.scheduledForDate" @change="getDateSchedule"/>
                </v-card-text>
              </v-card>
              <v-card class="mt-3" outlined>
                <v-card-title>
                  <h3 >Available Appointments</h3>
                </v-card-title>
                <v-card-text>
                  <v-progress-circular
                      indeterminate
                      color="green"
                      v-if="dateScheduleLoader"
                      style="margin-left: 10px;"
                  ></v-progress-circular>
                  <h3>{{ createAppointmentDialog.exemptionLabel }}</h3>              
                  <span class="d-flex flex-column" v-if="dateSchedule && dateSchedule.length > 0">
                    <v-radio-group v-model="createAppointmentDialog.appointment.scheduledForTime" @change="setAppointmentBlock">
                      <v-radio
                        v-for="(block,index) in dateSchedule"
                        :key="index"
                        :value="block"
                        :disabled="(!block.available||dateScheduleLoader) && !createAppointmentDialog.appointment.metadata.force"
                      >
                        <template v-slot:label>
                          <span v-if="block.available || createAppointmentDialog.appointment.metadata.force" style="width: 100%; height: 100%;" class="success mb-1 pa-2">
                            <div>{{ utils.convert24HourTime(block.time) }}</div>
                          </span>
                          <span v-else style="width: 100%; height: 100%;" class="warning my-1 pa-2">
                            <div> <strike>{{ block.time }}</strike> </div>
                          </span>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </span>
                  <span v-else>Select a date.</span>
                </v-card-text>
              </v-card>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeCreateAppointmentDialog">
            Cancel
          </v-btn>
          <v-btn color="success" :disabled="!createAppointmentDialog.isValid" @click="saveAppointment" :loading="createAppointmentDialog.isLoading">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="this.dialogs.directBulkPrint.isOpen" width="900" persistent>
      <v-card style="overflow-y:hidden">
        <v-card-title class="text-h5 d-flex flex-column align-center justify-center">
          <v-progress-circular
            indeterminate
            color="green"
            v-if="this.dialogs.directBulkPrint.loader"
            style="margin-top: 20px; margin-bottom: 10px;"
          ></v-progress-circular>
          <h3>Add items for Direct Bulk Print.</h3>
        </v-card-title>
        <v-card-text>
          <v-text-field autofocus v-model="dialogs.directBulkPrint.values" outlined></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="closeDirectBulkPrintDialog()">Cancel</v-btn>
          <v-btn color="primary" text @click="handleDirectBulkPrint()">Print</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="this.dialogs.bulkPrint.isOpen" width="900" persistent>
      <v-card style="overflow-y:hidden">
        <v-card-title class="text-h5 d-flex flex-column align-center justify-center">
          <v-progress-circular
            indeterminate
            color="green"
            v-if="this.dialogs.bulkPrint.loader"
            style="margin-top: 20px; margin-bottom: 10px;"
          ></v-progress-circular>
          <h3>Add items for Bulk Print.</h3>
        </v-card-title>
        <v-card-text>
          <v-text-field autofocus v-model="dialogs.bulkPrint.values" outlined></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="closeBulkPrintDialog()">Cancel</v-btn>
          <authorizer 
            v-if="dialogs.bulkPrint.values" 
            :buttontext="'Bulk Print'"
            :color="'success'" 
            :authorization="this.authorizations.bulkPrint" 
            v-on:response="handleBulkPrint($event)"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="this.dialogs.bulkOut.isOpen" width="900" persistent>
      <v-card style="overflow-y:hidden">
        <v-card-title class="text-h5 d-flex flex-column align-center justify-center">
          <v-progress-circular
            indeterminate
            color="green"
            v-if="this.dialogs.bulkOut.loader"
            style="margin-top: 20px; margin-bottom: 10px;"
          ></v-progress-circular>
          <h3>Add items for Bulk Out.</h3>
        </v-card-title>
        <v-card-text>
          <v-data-table
            outlined
            :headers="dialogs.bulkOut.tableHeaders"
            :items="this.scanBus.data"
            :items-per-page="-1"
            dense
          >
            <template v-slot:item.name="{ item }">
              #{{item.job.id}} [{{item.job.Tailor.metadata.shortName}}] {{item.job.Item.Customer.firstName}} {{item.job.Item.Customer.lastName}}
            </template>
            <template v-slot:item.remove="{ item}">
              <v-btn icon><v-icon @click="removeJob(item.job.id)">mdi-close</v-icon></v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="closeBulkOutDialog()">Cancel</v-btn>
          <authorizer 
            v-if="this.dialogs.bulkOut.isOpen&&this.scanBus.data&&this.scanBus.data.length>0&&this.scanBus.data.reduce((acc,job)=>acc&&job.ok,true)" 
            :buttontext="'Send Bulk Out'"
            :color="'success'" 
            :authorization="this.authorizations.bulkOut" 
            v-on:response="handleBulkOut($event)"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="this.dialogs.bulkIn.isOpen" width="900" persistent>
      <v-card style="overflow-y:hidden">
        <v-card-title class="text-h5 d-flex flex-column align-center justify-center">
          <v-progress-circular
            indeterminate
            color="green"
            v-if="this.dialogs.bulkIn.loader"
            style="margin-top: 20px; margin-bottom: 10px;"
          ></v-progress-circular>
          <h3>Add items for Bulk In.</h3>
        </v-card-title>
        <v-card-text>
          <v-data-table
            outlined
            :headers="dialogs.bulkIn.tableHeaders"
            :items="this.scanBus.data"
            :items-per-page="-1"
            dense
          >
            <template v-slot:item.name="{ item }">
              #{{item.job.id}} [{{item.job.Tailor.metadata.shortName}}] {{item.job.Item.Customer.firstName}} {{item.job.Item.Customer.lastName}}
            </template>
            <template v-slot:item.remove="{ item}">
              <v-btn icon><v-icon @click="removeJob(item.job.id)">mdi-close</v-icon></v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="closeBulkInDialog()">Cancel</v-btn>
          <authorizer 
            v-if="this.dialogs.bulkIn.isOpen&&this.scanBus.data&&this.scanBus.data.length>0&&this.scanBus.data.reduce((acc,job)=>acc&&job.ok,true)" 
            :buttontext="'Receive Bulk In'"
            :color="'success'" 
            :authorization="this.authorizations.bulkIn" 
            v-on:response="handleBulkIn($event)"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="this.dialogs.bulkCustomer.isOpen" width="900" persistent>
      <v-card style="overflow-y:hidden">
        <v-card-title class="text-h5 d-flex flex-column align-center justify-center">
          <v-progress-circular
            indeterminate
            color="green"
            v-if="this.dialogs.bulkCustomer.loader"
            style="margin-top: 20px; margin-bottom: 10px;"
          ></v-progress-circular>
          <h3>Add items for Bulk Customer Collect.</h3>
        </v-card-title>
        <v-card-text>
          <v-data-table
            outlined
            :headers="dialogs.bulkCustomer.tableHeaders"
            :items="this.scanBus.data"
            :items-per-page="-1"
            dense
          >
            <template v-slot:item.name="{ item }">
              #{{item.job.id}} [{{item.job.Tailor.metadata.shortName}}] {{item.job.Item.Customer.firstName}} {{item.job.Item.Customer.lastName}}
            </template>
            <template v-slot:item.remove="{ item}">
              <v-btn icon><v-icon @click="removeJob(item.job.id)">mdi-close</v-icon></v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="closeBulkCustomerDialog()">Cancel</v-btn>
          <authorizer 
            v-if="this.dialogs.bulkCustomer.isOpen&&this.scanBus.data&&this.scanBus.data.length>0&&this.scanBus.data.reduce((acc,job)=>acc&&job.ok,true)" 
            :buttontext="'Bulk Customer Collect'"
            :color="'success'" 
            :authorization="this.authorizations.bulkCustomer" 
            v-on:response="handleBulkCustomer($event)"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </div>
</template>
<script>
import { mapGetters, mapMutations} from 'vuex'
import axios from 'axios';
import moment from 'moment';
import authorizer from '../components/authorizer.vue';
import utils from '../plugins/helpers';
export default {
  name: 'Home',
  components: {
    authorizer
  },
  computed: {
    ...mapGetters(['getUsername', 'getEndpoint', 'scanBus', 'getPerms', 'getUserCache', 'getGlobalValue'])
  },
  data () {
    return {
      rn: '',
      utils: utils,
      loader: true,
      calenderLoader: false,
      snackObj: {
        color: '',
        text: ''
      },
      username: '',
      password: '',
      valid: false,
      focus: '',
      type: 'week',
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day',
        '4day': '4 Days',
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      eventsToDisplay: [],
      genders: [
        {name: "None",id: 0, value: 0},
        {name: "Groom 🤵", id: 1, value: 1},
        {name: "Bride 👰", id: 2, value: 2}
      ],
      types: [],
      statuses: [{name: "Cancelled", value: -1}, {name: "Pending", value: 0}, {name: "Started", value: 1}, {name: "Complete", value: 2}, {name: "Sealed", value: 3}],
      names: ['In', 'Out', 'Handed Off'],
      appointments: [],
      tomorrowAppointments: [],
      authorizations: {
        print: {type: 'scanAuthorize', authorized: false, authorizerId: '', resource: 'job', requiredPerm: 'printJobTicket', key:'printJobTicket'},
        bulkPrint: {type: 'scanAuthorize', authorized: false, authorizerId: '', resource: 'job', requiredPerm: 'printJobTicketBulk', key:'printJobTicketBulk'},
        bulkOut: {type: 'scanAuthorize', authorized: false, authorizerId: '', resource: 'job', requiredPerm: 'modifyJobStatusBulk', key:'modifyJobStatusBulk'},
        bulkIn: {type: 'scanAuthorize', authorized: false, authorizerId: '', resource: 'job', requiredPerm: 'modifyJobStatusBulk', key:'modifyJobStatusBulk'},
        bulkCustomer: {type: 'scanAuthorize', authorized: false, authorizerId: '', resource: 'job', requiredPerm: 'modifyJobStatusBulk', key:'modifyJobStatusBulk'},
      },
      filters:{
        status: '',
        csr: '',
        gender: '',
        type:'',
      },
      tailors: [],
      dialogs: {
        directBulkPrint: {
          isOpen: false,
          loader: false,
          values: ''
        },
        bulkPrint: {
          isOpen: false,
          loader: false,
          values: ''
        },
        bulkOut: {
          isOpen: false,
          loader: false,
          tableHeaders: [
            { text: 'JOB', align: 'start', sortable: false, value: 'name' },
            { text: 'OK', align: 'start', sortable: false, value: 'ok' },
            { text: 'MESSAGE', align: 'start', sortable: false, value: 'reason' },
            { text: 'REMOVE', align: 'start', sortable: false, value: 'remove' },
            
          ],
          tableItems: [],
          values: ''
        },
        bulkIn: {
          isOpen: false,
          loader: false,
          tableHeaders: [
            { text: 'JOB', align: 'start', sortable: false, value: 'name' },
            { text: 'OK', align: 'start', sortable: false, value: 'ok' },
            { text: 'MESSAGE', align: 'start', sortable: false, value: 'reason' },
            { text: 'REMOVE', align: 'start', sortable: false, value: 'remove' },
          ],
          tableItems: [],
          values: ''
        },
        bulkCustomer: {
          isOpen: false,
          loader: false,
          tableHeaders: [
            { text: 'JOB', align: 'start', sortable: false, value: 'name' },
            { text: 'OK', align: 'start', sortable: false, value: 'ok' },
            { text: 'MESSAGE', align: 'start', sortable: false, value: 'reason' },
            { text: 'REMOVE', align: 'start', sortable: false, value: 'remove' },
          ],
          tableItems: [],
          values: ''
        },
      },
      intentions: [],
      createAppointmentDialog: {
        isOpen: false,
        isValid: false,
        isLoading: false,
        appointment: {
          intentions: [],
          gender: 0,
          metadata: {
            force: false,
            firstAppointment: true  
          }
        },
        exemptionLabel: ''
      },
      customers: [],
      dateSchedule: [],
      appointmentTypes: [],
      dateScheduleLoader: false,
      findCustomerByPhoneLoader: false,
      newCustomer: {addresses: [], suggestedMatches: []},

      viewStart: '',
      viewEnd: '',
    }
  },
  async mounted(){
    try {
      await this.getAllData()

    } catch (error) {
      console.log(error)
    } finally {
      this.loader = false;
    }
  },
  methods: {
    ...mapMutations([
      'lockGlobalQueryBc',
      'unlockGlobalQueryBc',
      'setScanBusData',
      'setScanBusType',
      'resetScanBus',
    ]),
    async getAllData(){
      try {
        let res = await axios.get(`${this.getEndpoint}/api/appointmentTypes`)
        if(res.data.error) throw res.data.error
        this.types = res.data.data;
        this.tomorrowJobs = this.appointments.filter(x=>(moment(x.dateToHand).isBetween(moment(), moment().add(1,'days'))))

        res = await axios.get(`${this.getEndpoint}/api/activityTypes`)
        if(res.data.error) throw res.data.error;
        this.intentions = res.data.data;
        
        this.filtered = false
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      } finally {
        this.loader = false;
      }
    },
    setAppointmentBlock(){
      let x = new Date(this.createAppointmentDialog.appointment.scheduledForDate)
      let h = parseInt((this.createAppointmentDialog.appointment.scheduledForTime.time).split(":")[0])
      let m = parseInt((this.createAppointmentDialog.appointment.scheduledForTime.time).split(":")[1])
      x.setUTCHours(h)
      x.setUTCMinutes(m)
      this.createAppointmentDialog.appointment.scheduledFor = x
      this.updateAppointment()
    },
    async getDateSchedule(){
      try {
        if(!this.createAppointmentDialog.appointment.scheduledForDate) return
        
        this.createAppointmentDialog.exemptionLabel = ''
        this.dateScheduleLoader = true
        this.createAppointmentDialog.appointment.scheduledForTime = {}
        
        let res = await axios.get(`${this.getEndpoint}/api/appointments/byDate/${this.createAppointmentDialog.appointment.scheduledForDate}`)
        if(res.data.error) throw res.data.error
        
        let reservedBlocks = res.data.data

        this.dateSchedule = []
        let totalAvailableBlocks = (this.getGlobalValue('APPOINTMENT_AVAILABILITY_SCHEDULE'))

        let d = (new Date(this.createAppointmentDialog.appointment.scheduledForDate))
        let dayOfWeek = d.getUTCDay()
        let wordDayOfWeek = ["Sunday","Monday", "Tuesday","Wednesday", "Thursday", "Friday", "Saturday"]

        for(let block of totalAvailableBlocks.weekly[dayOfWeek]){
          for(let x = 0; x < parseInt(this.getGlobalValue('APPOINTMENTS_ALLOWED_SIMULTANEOUSLY')); x++){
            
            let isAvailable = true
            if(reservedBlocks.includes(block)){
              isAvailable = false
              reservedBlocks.splice(reservedBlocks.indexOf(block),1)
            }
            
            this.dateSchedule.push({
              block: x+1,
              dayWord: wordDayOfWeek[dayOfWeek],
              time: block,
              available: isAvailable, 
              isSelected: false
            })
          }
        }

        for(let exemption of totalAvailableBlocks.dayExemptions){
          if(exemption.repeating==="N"){ // N exemptions are non-repeating exemptions that must contain a date in the format YYYY-MM-DD
            // let splittedDate = exemption.day.split('-')
            // let formattedExemptionDate = `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`
            // console.log(formattedExemptionDate,this.createAppointmentDialog.appointment.scheduledForDate)
            if(exemption.day==this.createAppointmentDialog.appointment.scheduledForDate){
              this.createAppointmentDialog.exemptionLabel = exemption.label
              if(!exemption.allowedTimes || exemption.allowedTimes.length == 0){
                //block off entire day
                this.dateSchedule.forEach(x=>x.available = false)
              }else {
                this.dateSchedule.forEach(x=>x.available = false)
                for(let x of exemption.allowedTimes){
                  //block off blocks that are specified in the array
                  for(let item of this.dateSchedule){
                    if(item.time == x){
                      item.available = true
                    }
                  }
                }
              }
            }
          } else if(exemption.repeating==="W"){ // W exemptions are weekly-repeating exemptions that must contain the day key, whose value is an int, where sunday = 0 and saturday = 6
            console.log(exemption.day,d.getUTCDay())
            if(exemption.day==d.getUTCDay()){
              this.createAppointmentDialog.exemptionLabel = exemption.label
              if(!exemption.allowedTimes || exemption.allowedTimes.length == 0){
                //block off entire day
                this.dateSchedule.forEach(x=>x.available = false)
              }else {
                this.dateSchedule.forEach(x=>x.available = false)
                for(let x of exemption.allowedTimes){
                  //block off blocks that are specified in the array
                  for(let item of this.dateSchedule){
                    if(item.time == x){
                      item.available = true
                    }
                  }
                }
              }
            }
          } else if(exemption.repeating==="M"){ // M exemptions are monthly-repeating exemptions that must contain the day key, whose value is an int that corresponds to the day of the month 
            if(exemption.day==d.getUTCDate()){
              this.createAppointmentDialog.exemptionLabel = exemption.label
              if(!exemption.allowedTimes || exemption.allowedTimes.length == 0){
                //block off entire day
                this.dateSchedule.forEach(x=>x.available = false)
              }else {
                this.dateSchedule.forEach(x=>x.available = false)
                for(let x of exemption.allowedTimes){
                  //block off blocks that are specified in the array
                  for(let item of this.dateSchedule){
                    if(item.time == x){
                      item.available = true
                    }
                  }
                }
              }
            }
          } else if(exemption.repeating==="Y"){ // Y exemptions are yearly-repeating exemptions that must contain the day key, whose value is a string of the format DD/MM

            let splittedDate = exemption.day.split('/')
            let selectedDateSplitted = this.createAppointmentDialog.appointment.scheduledForDate.split("-")

            let formattedExemptionDay = splittedDate[0]
            let formattedExemptionMonth = splittedDate[1]
            let selectedDateDay = selectedDateSplitted[2]
            let selectedDateMonth = selectedDateSplitted[1]

            if(formattedExemptionMonth==selectedDateMonth && formattedExemptionDay==selectedDateDay){
              this.createAppointmentDialog.exemptionLabel = exemption.label
              console.log(exemption)
              if(!exemption.allowedTimes || exemption.allowedTimes.length == 0){
                //block off entire day
                this.dateSchedule.forEach(x=>x.available = false)
              }else {
                this.dateSchedule.forEach(x=>x.available = false)
                for(let x of exemption.allowedTimes){
                  //block off blocks that are specified in the array
                  for(let item of this.dateSchedule){
                    if(item.time == x){
                      item.available = true
                    }
                  }
                }
              }
            }
          } else {
            this.createAppointmentDialog.exemptionLabel = ''
          }
        }

      } catch (error) {
        console.log(error.msg || error)
        this.snack(error)
      } finally {
        this.dateScheduleLoader = false
      }
    },
    async saveAppointment(){
      try {
        this.createAppointmentDialog.isLoading = true;

        console.log(this.createAppointmentDialog.appointment)

        let res = await axios.post(`${this.getEndpoint}/api/appointments`, this.createAppointmentDialog.appointment)
        if(res.data.error) throw res.data.error;
        this.snack(`Appointment Created 🎉`);

        this.closeCreateAppointmentDialog();
        await this.getAllData();
      } catch (error) {
        console.log(error)          
      }finally {
        this.createAppointmentDialog.isLoading = false;
      }
    },
    updateAppointment(){
      let temp = true
      if(!this.createAppointmentDialog.appointment) temp = false
      if(this.createAppointmentDialog.appointment.intentions.length < 1) temp = false
      if(!this.createAppointmentDialog.appointment.budget) temp = false
      if(!this.createAppointmentDialog.appointment.occupants) temp = false
      if(!this.createAppointmentDialog.appointment.customerName) temp = false
      if(!this.createAppointmentDialog.appointment.customerPhone) temp = false
      if(!this.createAppointmentDialog.appointment.scheduledFor) temp = false
      if(!this.createAppointmentDialog.appointment.weddingDate) temp = false
      this.createAppointmentDialog.isValid = temp
    },
    clearCustomerSuggestions(){
      this.newCustomer.suggestedMatches = []
    },
    async findCustomerByPhone(){
      try {
        this.createAppointmentDialog.appointment.customerName = ""
        this.createAppointmentDialog.appointment.customerId = ""
        if(!this.createAppointmentDialog.appointment?.customerPhone){
          this.newCustomer.suggestedMatches = []
          return
        }
        if(this.createAppointmentDialog.appointment?.customerPhone?.length < 3) return
        this.findCustomerByPhoneLoader = true
        let res = await axios.get(`${this.getEndpoint}/api/customers/byPhone/${this.createAppointmentDialog.appointment.customerPhone}`)
        this.newCustomer.suggestedMatches = res.data.data
        this.findCustomerByPhoneLoader = false
        this.updateAppointment()
      } catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error")
        this.findCustomerByPhoneLoader = false
      }
    },
    setCustomer(cust){
      this.createAppointmentDialog.appointment.customerId = cust.id;
      this.createAppointmentDialog.appointment.customerPhone = cust.phone;
      this.createAppointmentDialog.appointment.customerName = cust.firstName + " " + cust.lastName;
      this.createAppointmentDialog.appointment.customerEmail = cust.email;
      this.createAppointmentDialog.appointment.customerLine1 = cust.address?.line1||'';
      this.createAppointmentDialog.appointment.customerLine2 = cust.address?.line2||'';
      this.createAppointmentDialog.appointment.customerCity = cust.address?.city||'';
      this.newCustomer.suggestedMatches = []
      this.updateAppointment()
    },
    
    openCreateAppointmentDialog(){
      this.createAppointmentDialog.isOpen = true
    },
    closeCreateAppointmentDialog(){
      this.createAppointmentDialog = {
        isOpen: false,
        isValid: false,
        isLoading: false,
        appointment: {gender: 0, intentions: [], metadata: {force:false, firstAppointment: true}},
        exemptionLabel: ''
      }
    },
    async create(){
      try {
        let res = await axios.post(`${this.getEndpoint}/api/appointments`, this.data)
        if(res.data.error) throw res.data.error

        this.snack(`Appointment Created 🎉`, "success");

        this.data={
          name: "",
          location: "",
          serial: "",
          documentTypes: [],
          data: {},
          metadata: {}
        };
        await this.getAllData();
      } catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
      }
    },
    getEventIconForType(t){
      switch(t){
        case 1:
          return '🚶‍♂️'
        case 2:
          return "📞"
        case 3:
        return "💻"
      }
      return ""
    },
    async loadEvents(start, end){
      try{
        this.calenderLoader = true;

        this.eventsToDisplay = [];
        this.events = [];

        let res = await axios.get(`${this.getEndpoint}/api/appointments/search?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`);
        if(res.data.error) throw res.data.error;

        this.appointments = res.data.data;

        this.appointments.forEach(a=>{

          a.scheduledForStart = this.utils.formatForStartAppointmentCalendar(a.scheduledFor)
          a.scheduledForEnd = this.utils.formatForEndAppointmentCalendar(a.scheduledFor,a.duration)

          this.events.push({
            name: (this.getEventIconForType(a.appointmentType)) + a.Customer.firstName + " " + a.Customer.lastName,
            appointment: a,
            start: a.scheduledForStart,
            end: a.scheduledForEnd,
            color: utils.getAppointmentStatusColor(a.status),
            timed: false
          })
        })
        this.eventsToDisplay = this.events  //events to display after all search and filters
        this.$refs?.calendar.scrollToTime('7:00')
      }catch (e) {
        this.snack(e)
      } finally {
        this.calenderLoader = false;
      }
    },
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor (event) {
      return event.color
    },
    getEventColorFromStatus (status) {
      switch(status){
        case -1:
          return 'error'
        case 0:
          return 'warning'
        case 1:
          return 'success'
        case 2:
          return 'info'
        case 3:
          return 'yellow'

      }
    },
    setToday() {
      this.focus = ''
      this.type = 'day'
    },
    setTodayWeek() {
      this.focus = ''
      this.type = 'week'
    },
    prev () {
      this.$refs.calendar.prev()
      this.clearFilters()
    },
    next () {
      this.$refs.calendar.next()
      this.clearFilters()
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    async updateRange (event) {
      let viewStart = this.$refs.calendar.getStartOfWeek(event.start).date;
      let viewEnd = this.$refs.calendar.getEndOfWeek(event.end).date;

      this.viewStart = viewStart;
      this.viewEnd = viewEnd;

      await this.loadEvents(viewStart, viewEnd)
    },
    rnd (a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
    momentDateFormat (date) {
      return date ? moment(this.parseISODate(date)).format('ddd, MMM Do YYYY') : '';
    },
    parseISODate(date){
      return (date?new Date(date).toISOString().substring(0, 10):null);
    },
    parseAppointmentStatus(id){
      if(id===-1) return "Cancelled"
      else if(id===0) return "Pending"
      else if(id===1) return "Started"
      else if(id===2) return "Completed"
      else if(id===2) return "Completed"
    },
    parseAppointmentGender(id){
      if(id===0) return ("None")
      else if(id===1) return ("Male")
      else if(id===2) return ("Female")
    },
    parseAppointmentType(id){
      switch(id){
        case 1:
          return "Walk-in"
        case 2:
          return "Call"
        case 3:
          return "Online"
      }
    },
    goToAppointment(a){
      return this.$router.push({path: `/appointments/view/${a}`})
    },
    async attemptPrint(e){
      try {
          if(!e.pin&&!e.vsidToken) throw "Error Getting Credentials"
          let res = await axios.post(`${this.getEndpoint}/api/print/jobTicket/${this.selectedEvent.appointment.id}`, e)
          if(res.data.error) throw res.data.error
      } catch (error) {
        console.log(error)
        this.snack(error)
      }
    },
    filterByStatus(){
      this.eventsToDisplay = this.eventsToDisplay.filter(x=>x.appointment.status==this.filters.status)
    },
    filterByCSR(){
      this.eventsToDisplay = this.eventsToDisplay.filter(x=>x.appointment.createdBy==this.filters.csr)
    },
    filterByGender(){
      this.eventsToDisplay = this.eventsToDisplay.filter(x=>x.appointment.gender==this.filters.gender)
    },
    filterByType(){
      this.eventsToDisplay = this.eventsToDisplay.filter(x=>x.appointment.appointmentType==this.filters.type)
    },
    clearFilters(){
      this.eventsToDisplay = this.events
      this.filters.status = ""
      this.filters.gender = ""
      this.filters.csr = ""
      this.filters.type = ""
    },
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.color = color;

      this.$refs.snackbar.openDialog();
    },
    openDirectBulkPrintDialog(){
      this.dialogs.directBulkPrint.isOpen = true
      this.dialogs.directBulkPrint.loader = false
    },
    closeDirectBulkPrintDialog(){
      this.dialogs.directBulkPrint.isOpen = false
      this.dialogs.directBulkPrint.loader = false
      this.dialogs.directBulkPrint.values = ''
    },
    openBulkPrintDialog(){
      this.dialogs.bulkPrint.isOpen = true
      this.dialogs.bulkPrint.loader = false
    },
    closeBulkPrintDialog(){
      this.dialogs.bulkPrint.isOpen = false
      this.dialogs.bulkPrint.loader = false
      this.dialogs.bulkPrint.values = ''
    },
    openBulkOutDialog(){
      this.dialogs.bulkOut.isOpen = true
      this.dialogs.bulkOut.loader = false
      this.resetScanBus()
      this.setScanBusType('out')
      this.setScanBusData([])
    },
    closeBulkOutDialog(){
      this.dialogs.bulkOut.isOpen = false
      this.dialogs.bulkOut.loader = false
      this.setScanBusType('job')
      this.setScanBusData([])
    },
    async handleDirectBulkPrint(){
      try {
        let res = await axios.post(`${this.getEndpoint}/api/print/directJobTicketBulk`, {jobs: this.dialogs.directBulkPrint.values})
        let printWindow = open("","Printing")
        printWindow.document.write(res.data.data.job.htmlToPrint)
        printWindow.setTimeout(()=>{
          printWindow.print()
        },300)
      } catch (error) {
        console.log(error)
        this.snack(error)
        this.closeDirectBulkPrintDialog()
      }
    },
    async handleBulkPrint(e){
      try {
        e.jobs = this.dialogs.bulkPrint.values
        let res = await axios.post(`${this.getEndpoint}/api/print/jobTicketBulk`, e)
        if(res.data.success){
          this.snack("Bulk Operation Successful")
          this.closeBulkPrintDialog()
        }
        else throw res.data.error
      } catch (error) {
        console.log(error)
        this.snack(error)
        this.closeBulkPrintDialog()
      }
    },
    async handleBulkOut(e){
      try {
        let toSend = this.scanBus.data
        toSend.forEach(x=>x.job = x.job.id)
        e.jobs = toSend
        let res = await axios.put(`${this.getEndpoint}/api/jobs/sendOffBulk/`, e)
        if(res.data.success){
          this.snack("Bulk Operation Successful")
          this.closeBulkOutDialog()
        }
        else throw res.data.error
      } catch (error) {
        console.log(error)
        this.snack(error)
        this.closeBulkOutDialog()
      }
    },
    async handleBulkIn(e){
      try {
        let toSend = this.scanBus.data
        toSend.forEach(x=>x.job = x.job.id)
        e.jobs = toSend
        let res = await axios.put(`${this.getEndpoint}/api/jobs/receiveInBulk/`, e)
        if(res.data.success){
          this.snack("Bulk Operation Successful")
          this.closeBulkOutDialog()
        }
        else throw res.data.error
      } catch (error) {
        console.log(error)
        this.snack(error)
        this.closeBulkOutDialog()
      }
    },
    async handleBulkCustomer(e){
      try {
        let toSend = this.scanBus.data
        toSend.forEach(x=>x.job = x.job.id)
        e.jobs = toSend
        let res = await axios.put(`${this.getEndpoint}/api/jobs/handOffBulk/`, e)
        if(res.data.success){
          this.snack("Bulk Operation Successful")
          this.closeBulkCustomerDialog()
        }
        else throw res.data.error
      } catch (error) {
        console.log(error)
        this.snack(error)
        this.closeBulkCustomerDialog()
      }
    },
    openBulkInDialog(){
      this.dialogs.bulkIn.isOpen = true
      this.dialogs.bulkIn.loader = false
      this.setScanBusType('in')
      this.setScanBusData([])
    },
    closeBulkInDialog(){
      this.dialogs.bulkIn.isOpen = false
      this.dialogs.bulkIn.loader = false
      this.setScanBusType('job')
      this.setScanBusData([])
    },
    openBulkCustomerDialog(){
      this.dialogs.bulkCustomer.isOpen = true
      this.dialogs.bulkCustomer.loader = false
      this.setScanBusType('customer')
      this.setScanBusData([])
    },
    closeBulkCustomerDialog(){
      this.dialogs.bulkCustomer.isOpen = false
      this.dialogs.bulkCustomer.loader = false
      this.setScanBusType('job')
      this.setScanBusData([])
    },
    removeJob(id){
      let temp = this.scanBus.data
      this.setScanBusData(temp.filter(x=>x.job.id != id))
    },
    lookupIntention(val){
      let result = this.intentions.find(x=>x.id==parseInt(val))
      if(!result || result == undefined) result = "N/A"
      return result
    }
  }
}
</script>
